import { PhoneInput } from '@/components/PhoneInput';
import { SelectInput } from '@/components/SelectInput';
import { TextEditor } from '@/components/TextEditor';
import { TextInput } from '@/components/TextInput';
import { CreateEventForm } from '@/types/event';
import { FormikProps } from 'formik';
import { useTranslation } from 'react-i18next';

interface CreateEventInformationsProps {
  errors: FormikProps<CreateEventForm>['errors'];
  touched: FormikProps<CreateEventForm>['touched'];
  values: FormikProps<CreateEventForm>['values'];
  handleChange: FormikProps<CreateEventForm>['handleChange'];
}

export const CreateEventInformations = ({
  errors,
  touched,
  values,
  handleChange,
}: CreateEventInformationsProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <TextInput
          label={t('createEvent:name')}
          type="text"
          name="name"
          isRequired
          placeholder={t('createEvent:name')}
          error={!!errors.name && !!touched.name}
        />

        <TextInput
          label={t('createEvent:location')}
          type="text"
          name="location"
          isRequired
          placeholder={t('createEvent:location')}
          error={!!errors.location && !!touched.location}
        />

        <TextInput
          label={t('common:fields.start_date')}
          type="datetime-local"
          name="date"
          isRequired
          placeholder={t('common:fields.start_date')}
          error={!!errors.date && !!touched.date}
        />

        <TextInput
          label={t('common:fields.end_date')}
          type="datetime-local"
          name="end_date"
          isRequired
          placeholder={t('common:fields.end_date')}
          error={!!errors.end_date && !!touched.end_date}
        />

        <TextInput
          label={t('createEvent:email')}
          type="email"
          name="email"
          placeholder={t('createEvent:email')}
          error={!!errors.email && !!touched.email}
        />

        <PhoneInput
          label={t('createEvent:phone')}
          name="phone"
          placeholder={t('createEvent:phone')}
          error={!!errors.phone && !!touched.phone}
        />

        <SelectInput
          label={t('createEvent:type')}
          name="type"
          isRequired
          defaultValue={values.type}
          onChange={handleChange}
          options={[
            { value: 'public', label: t('common:type.public') },
            { value: 'private', label: t('common:type.private') },
          ]}
          error={errors.type}
        />

        <SelectInput
          label={t('createEvent:status')}
          name="status"
          defaultValue={values.status}
          onChange={handleChange}
          options={[
            { value: 'future', label: t('common:status.future') },
            { value: 'ongoing', label: t('common:status.ongoing') },
            { value: 'past', label: t('common:status.past') },
          ]}
          error={errors.status}
        />

        <TextInput
          label={t('createEvent:category')}
          type="text"
          name="category"
          placeholder={t('createEvent:category')}
          error={!!errors.category && !!touched.category}
        />

        <TextInput
          label={t('createEvent:organizer')}
          type="text"
          name="organizer"
          placeholder={t('createEvent:organizer')}
          error={!!errors.organizer && !!touched.organizer}
        />

        <TextInput
          label={t('createEvent:maximum_participants')}
          type="number"
          name="maximum_participants"
          min={1}
          placeholder={t('createEvent:maximum_participants')}
          error={
            !!errors.maximum_participants && !!touched.maximum_participants
          }
        />
        <SelectInput
          label={t('createEvent:show_capacity')}
          name="show_capacity"
          placeholder={t('createEvent:show_capacity')}
          onChange={handleChange}
          defaultValue={values.show_capacity}
          options={[
            { value: true, label: t('common:yes') },
            { value: false, label: t('common:no') },
          ]}
        />
      </div>

      <div className="mt-2">
        <TextEditor
          label={t('createEvent:description')}
          name="description"
          isRequired
          placeholder={t('createEvent:description')}
          error={!!errors.description && !!touched.description}
        />
      </div>
    </>
  );
};
